import P1 from "../Assets/Projects/P1.png";
// import P2 from "../Assets/Projects/P2.png";
// import P3 from "../Assets/Projects/P3.png";
import P4 from "../Assets/Projects/P4.png";
// import P5 from "../Assets/Projects/P5.png";
import P6 from "../Assets/Projects/P6.png";
// import P7 from "../Assets/Projects/P7.png";
import P8 from "../Assets/Projects/P8.png";
import P9 from "../Assets/Projects/P9.png";
import P10 from "../Assets/Projects/P10.png";
import P11 from "../Assets/Projects/P11.png";
import C1 from "../Assets/Community/C1.png";
import C2 from "../Assets/Community/C2.png";
import E1 from "../Assets/Experience/E1.png";
import E2 from "../Assets/Experience/E2.png";
import A1 from "../Assets/Achievements/A1.png";
import A2 from "../Assets/Achievements/A2.png";
import A3 from "../Assets/Achievements/A3.png";
import Ct1 from "../Assets/Certificates/Ct1.png";
import Ct2 from "../Assets/Certificates/Ct2.png";
import Ct3 from "../Assets/Certificates/Ct3.png";
import Ct4 from "../Assets/Certificates/Ct4.png";
import Ct5 from "../Assets/Certificates/Ct5.png";
import Ct6 from "../Assets/Certificates/Ct6.png";
import Ct7 from "../Assets/Certificates/Ct7.png";
import Ct8 from "../Assets/Certificates/Ct8.png";
import Ct9 from "../Assets/Certificates/Ct9.png";
import Ct10 from "../Assets/Certificates/Ct10.png";
import Ct11 from "../Assets/Certificates/Ct11.png";
import Ct12 from "../Assets/Certificates/Ct12.png";
import Ct13 from "../Assets/Certificates/Ct13.png";
import Ct14 from "../Assets/Certificates/Ct14.png";

const certificates = [
  // projects can be added an removed
  // if there are no projects, Projects section won't show up
  {
    title: 'Hackin UTU: Top 25',
    description: 'Hackathon',
    image: Ct1,
    link: 'https://drive.google.com/file/d/1l7cVBzMQd6_JJxvWp6TPYAIxhH-zjphU/view?usp=sharing',
  },
  {
    title: 'NEO Olympiad: Qualified R1',
    description: 'Hackathon',
    image: Ct2,
    link: 'https://drive.google.com/file/d/1g41zqAzDE2ewsUU1HFJ05hPGuhGN9aG7/view?usp=sharing',
  },
  {
    title: 'iOS App Development Bootcamp',
    description: 'Hackathon',
    image: Ct10,
    link: 'https://udemy-certificate.s3.amazonaws.com/pdf/UC-8c1688d6-cc3b-489b-8811-2f15e20e8cd8.pdf',
  },
  {
    title: 'Google IT Automation',
    description: 'Hackathon',
    image: Ct3,
    link: 'https://www.coursera.org/account/accomplishments/specialization/certificate/EGW3XEXTPMVA',
  },
  {
    title: 'IBM Data Science',
    description: 'Hackathon',
    image: Ct4,
    link: 'https://www.coursera.org/account/accomplishments/specialization/certificate/T8UPAQS57Z6X',
  },
  {
    title: 'Applied Data Science',
    description: 'Hackathon',
    image: Ct5,
    link: 'https://www.coursera.org/account/accomplishments/specialization/certificate/X788XDBKRG2D',
  },
  {
    title: 'Python 3 Programming',
    description: 'Hackathon',
    image: Ct6,
    link: 'https://www.coursera.org/account/accomplishments/specialization/certificate/RXTMAS2ULL3F',
  },
  {
    title: 'Data Structures and Algorithms',
    description: 'Hackathon',
    image: Ct7,
    link: 'https://www.coursera.org/account/accomplishments/specialization/certificate/MY8DTQVEDL5C',
  },
  {
    title: 'Reinforcement Learning',
    description: 'Hackathon',
    image: Ct8,
    link: 'https://www.coursera.org/account/accomplishments/specialization/certificate/NT9ZE6A3FUCD',
  },
  {
    title: 'IBM AI Engineering',
    description: 'Hackathon',
    image: Ct9,
    link: 'https://www.coursera.org/account/accomplishments/specialization/certificate/3TG2K9YEZAPY',
  },
  {
    title: 'Natural Language Processing in TensorFlow',
    description: 'Hackathon',
    image: Ct11,
    link: 'https://www.coursera.org/account/accomplishments/certificate/XQMGBCSBDUPP',
  },
  {
    title: 'PHP Course',
    description: 'Hackathon',
    image: Ct12,
    link: 'https://www.sololearn.com/Certificate/1059-14856385/pdf/',
  },
  {
    title: 'Python Code Course',
    description: 'Hackathon',
    image: Ct13,
    link: 'https://www.sololearn.com/Certificate/1073-14856385/pdf/',
  },
  {
    title: 'HTML Course',
    description: 'Hackathon',
    image: Ct14,
    link: 'https://www.sololearn.com/Certificate/1014-14856385/pdf/',
  },
]

const experienes = [
  // projects can be added an removed
  // if there are no projects, Projects section won't show up
  {
    title: 'Associate Software Engineer (Dec 2022 - Present)',
    description: 'I work as ASE at HhaeXchange, a healthcare US based firm. I am working with technologies like VB.NET, SQL and mostly backend task.',
    image: E2,
    link: 'https://www.hhaexchange.com/',
  },
  {
    title: 'Project Intern (May 2021 - June 2021)',
    description: 'I got this oppurtunity from CISCO Networking Academy through my university to learn about networking and basics of Cyber Security. I successfully completed my capstone project on desginging computer networking for the university and implementing security protocols in it.',
    image: E1,
    link: 'https://drive.google.com/file/d/1ultxgoZYI0_ntslQFdoBNOkKhwlsL304/view?usp=sharing',
  },
]

const achievements = [
  // projects can be added an removed
  // if there are no projects, Projects section won't show up
  {
    title: 'Uncript Rookies Hackathon',
    description: 'Our team MSDO7 was declared winner of Unscript Rookies Hackathon 2020 with 50+ participating teams. We had built canteen management applications to manage online orders and payments in University Canteens.',
    stack: ['Winner', 'Nov 2020'],
    image: A1,
    link: 'https://drive.google.com/file/d/1FWNL_vHXJ60xDXyTEeP0MOuUep13SwB3/view?usp=sharing',
  },
  {
    title: 'DSC WOW Hackathon',
    description: 'Our team was one of the top 20 teams in the national level DSC WOW Hackathon with 250+ participating teams.',
    stack: ['Top 20 Teams', 'Dec 2020'],
    image: A2,
    link: 'https://drive.google.com/file/d/1tIUC1HX_4JCdzMlDnaLAnI-IPfQJlXeC/view?usp=sharing',
  },
  {
    title: 'WonderWeb',
    description: 'Secured 2nd position in Website Designing competition “Wonder Web” in Techno-Cultural fest organised by university.',
    stack: ['Runner-up', 'March 2020'],
    image: A3,
    link: 'https://drive.google.com/file/d/1QbdL-1Mh4FB-fL5Tp88bIMABsu777Ca6/view?usp=sharing',
  },
]

const selectedProjects = [
  {
    title: 'Apna Canteen (Admin)',
    description:
      'It is the admin side of canteen management application, which provides controls to the canteen owner to open/close the canteen, manage orders and their payments, add/modify/delete new products and view their sales report.',
    stack: ['Flutter', 'Firebase', 'Dart'],
    sourceCode: 'https://github.com/deeppatel23/DSCWOW-CANTEEN_MANAGEMENT',
    livePreview: 'https://github.com/deeppatel23/DSCWOW-CANTEEN_MANAGEMENT',
    image: P1,
  },
  {
    title: 'Cashflow Minimizer',
    description:
      'In this application, you can find minimum cash flow between n people. Insert data in the table where cell represent the value person i has to pay to person j. On computing the result, you will get answer with minimum cash flow between persons.',
    stack: ['Graph', 'Greedy', 'React'],
    sourceCode: 'https://github.com/deeppatel23/CashFlowMinimizer',
    livePreview: 'https://cash-flow-minimizer.vercel.app/',
    image: P4,
  },
  {
    title: 'Aarogyam Buddy',
    description:
      'Aarogyam Buddy is fully fledged healthcare app with in-app diagnosis and doctor appointment feature. Its Doctor and Admin panel provides smooth interaction with different user functionality.',
    stack: ['Flutter', 'Firebase', 'DialogFlow'],
    sourceCode: 'https://github.com/deeppatel23/AarogymaBuddy',
    livePreview: 'https://youtu.be/9avo2aTbV2Y',
    image: P6,
  },
]

const projects = [
  // projects can be added an removed
  // if there are no projects, Projects section won't show up
  {
    title: 'Log Ingestor and Query Application',
    description:
      'I have developed a log ingestor system that can efficiently handle vast volumes of log data, and I have also built a simple interface for querying this data using full-text search and specific field filters.',
    stack: ['Spring Boot', 'Java', 'MySQL', 'Apache Kafka'],
    sourceCode: 'https://github.com/deeppatel23/Log-Ingestor-and-Query',
    livePreview: 'https://youtu.be/vhMLkbmORoA?si=FP8rnl8BjUdl_QLn',
    image: P11,
  },
  {
    title: 'Parking Management System',
    description:
      ' Parking management is designed to automate the parking system with hassle free admin and user app. This is a back-end project will all APIs made in Spring Boot and currently in development stage.',
    stack: ['Spring Boot', 'Java', 'MySQL'],
    sourceCode: 'https://github.com/deeppatel23/parking-system',
    livePreview: 'https://github.com/deeppatel23/parking-system',
    image: P9,
  },
  {
    title: 'CodeShare',
    description:
      ' Parking management is designed to automate the parking system with hassle free admin and user app. This is a back-end project will all APIs made in Spring Boot and currently in development stage.',
    stack: ['React JS', 'Node JS', 'Socket.io'],
    sourceCode: 'https://github.com/deeppatel23/CodeShare-Client',
    livePreview: 'https://code-share-7wx9.onrender.com/',
    image: P10,
  },
  {
    title: 'Aarogyam Buddy',
    description:
      'Aarogyam Buddy is fully fledged healthcare app with in-app diagnosis and doctor appointment feature. Its Doctor and Admin panel provides smooth interaction with different user functionality.',
    stack: ['Flutter', 'Firebase', 'DialogFlow'],
    sourceCode: 'https://github.com/deeppatel23/AarogymaBuddy',
    livePreview: 'https://youtu.be/9avo2aTbV2Y',
    image: P6,
  },
  {
    title: 'Apna Canteen (Admin and User)',
    description:
      'The admin side of canteen management application provides controls to the canteen owner to open/close the canteen, manage orders and their payments. And user side of a canteen management application provides facility to place food orders and options for e-payment.',
    stack: ['Flutter', 'Firebase', 'Dart'],
    sourceCode: 'https://github.com/deeppatel23/DSCWOW-CANTEEN_MANAGEMENT',
    livePreview: 'https://github.com/deeppatel23/DSCWOW-CANTEEN_MANAGEMENT',
    image: P1,
  },
  // {
  //   title: 'Apna Canteen (User)',
  //   description:
  //     'This is the user side of a canteen management application which provides facility to place food orders and options for e-payment. The app opens only if the canteen is open, else it shows we are closed. It also notifies the user when their order is ready.',
  //   stack: ['Flutter', 'Firebase', 'Dart'],
  //   sourceCode: 'https://github.com/deeppatel23/DSCWOW-CANTEEN_MANAGEMENT',
  //   livePreview: 'https://github.com/deeppatel23/DSCWOW-CANTEEN_MANAGEMENT',
  //   image: P2,
  // },
  // {
  //   title: 'SkinShine',
  //   description:
  //     'It is a skin disease prediction app which predicts deiseases from image. It also provides many features for skincare like home remedies for daily skin problems, expert assistance 24/7, 30-day glowing skin challange, water reminder etc.',
  //   stack: ['Flutter', 'Firebase', 'Dart', 'DialogFlow'],
  //   sourceCode: 'https://github.com/Manzee1609/SkinDisease-ML-app',
  //   livePreview: 'https://github.com/Manzee1609/SkinDisease-ML-app',
  //   image: P3,
  // },
  {
    title: 'Cashflow Minimizer',
    description:
      'In this application, you can find minimum cash flow between n people. Insert data in the table where cell represent the value person i has to pay to person j. On computing the result, you will get answer with minimum cash flow between persons.',
    stack: ['React','Graph', 'Greedy'],
    sourceCode: 'https://github.com/deeppatel23/CashFlowMinimizer',
    livePreview: 'https://cash-flow-minimizer.vercel.app/',
    image: P4,
  },
  {
    title: 'File Compressor',
    description:
      'This application lets you compress and de-compress your text files. Huffman coding algorithm is used to perform lossless file compression.',
    stack: [ 'React', 'Huffman'],
    sourceCode: 'https://github.com/deeppatel23/File-compressor',
    livePreview: 'https://file-compressor-deeppatel23.vercel.app/',
    image: P8,
  },
  // {
  //   title: 'Calcula',
  //   description:
  //     'Calcula is a calculator iOS app, that uses Machine Learning to scan bills and add them. It can also scan and solve mathematical expression.',
  //   stack: ['iOS', 'Swift', 'Vision'],
  //   sourceCode: 'https://github.com/deeppatel23/Calcula',
  //   livePreview: 'https://drive.google.com/file/d/14eEtDhaIyX__vnZKcTdi1wwRWwSmWwv4/view?usp=sharing',
  //   image: P5,
  // },
  // {
  //   title: 'Diary Management',
  //   description:
  //     'This is Django application with SQLite database to support user Register/Login and CRUD operation on data.',
  //   stack: ['Django', 'SQlite'],
  //   sourceCode: 'https://github.com/deeppatel23/Diary_Management',
  //   livePreview: 'https://www.linkedin.com/posts/deep-patel-92b95b1a3_diary-diarymanagement-journaling-activity-6731604737482911744-eogV',
  //   image: P7,
  // },
]

const community = [
  // projects can be added an removed
  // if there are no projects, Projects section won't show up
  {
    title: 'Computer Society of India, Student Branch, DDU',
    position: 'President',
    year: '2021-2022',
    description:
      'As a President of CSI DDU, I empower my team to achieve our goals and contribute to the community.',
    stack: ['SASS', 'TypeScript', 'React'],
    sourceCode: 'https://github.com',
    livePreview: 'http://csiddu.in/',
    image: C1,
  },
  {
    title: 'Developer Student Club',
    position: 'Mobile Dev Team Member and Co-Lead',
    year: '2021-Present',
    description:
      'I am a part of Android team of DSC DDU and also Co-Lead. With my app development skills I empower my team to organise workshops and events.',
    stack: ['SASS', 'TypeScript', 'React'],
    sourceCode: 'https://github.com',
    livePreview: 'https://www.dscddu.com/',
    image: C2,
  },
  {
    title: 'Computer Society of India, Student Branch, DDU',
    position: 'Associate',
    year: '2020-2021',
    description:
      'As a junior associate at CSI DDU, I have learned multiple soft skills like Public speaking, content writing and social media managing. Furthur, the club gave me the oppurtunity to interact with multiple people and improve my communication skills.',
    stack: ['SASS', 'TypeScript', 'React'],
    sourceCode: 'https://github.com',
    livePreview: 'http://csiddu.in/',
    image: C1,
  },
]


export { selectedProjects, projects, certificates, achievements, community, experienes }